import { css } from 'goober';
import { dlg } from '../dlg';
import { config } from '../services/config';
import { openGuidelines } from '../dialogs/guidelines';
import { openSupportDlg } from '../dialogs/supportDlg';
import { makeAutoObservable } from 'mobx';
import { state, state_init } from '../services/state';
import { openLoginDlg } from '../dialogs/loginDlg';
import { format_phone, plural, validate_phone } from '../utils/utils';
import { createEffect, For } from 'solid-js';
import { useNavigate } from '@solidjs/router';
import { autofocus } from '../utils/autofocus';
import { openToast } from '../dialogs/toast';
import { api } from '../services/api';
import { ContactType } from '../dialogs/postingDlg';

interface ILocSummary {
	id: number;
	name: string;
	zip: string;
	state: string;
	providers: number;
	active: number;
	posts: IPost[];
}

interface ITestProvider {
	name: string;
	tags: string[];
	desc?: string;
	active?: boolean;
}

const providers: ITestProvider[] = [
	{
		name: 'Mark Westbrook',
		desc: 'Looking to help out fellow locals in the Atchison county area.',
		tags: ['clothing', 'shelter', 'housing', 'rent', 'utility bills', 'food', 'transportation'],
		active: true
	},
	{
		name: 'St. Vincent De Paul',
		desc: '',
		tags: ['clothing', 'shelter', 'housing', 'rent', 'utility bills', 'food', 'transportation'],
		active: true
	},
	{
		name: 'Abc St. Parish',
		desc: '',
		tags: ['clothing', 'shelter', 'housing', 'rent', 'utility bills', 'food', 'transportation'],
		active: false
	}
];

const l = makeAutoObservable({
	loading: true,
	locations: [] as ILocSummary[],
	providers
	//locations:[] as ILocation[]
});

const c_post = css`
	border: 1px solid;
	padding: 10px;
	border-radius: 5px;
`;

const c_tag = css`
	background: green;
	color: white;
	border-radius: 5px;
	display: inline-block;
	padding: 1px 4px;
`;

const c_inactive_tag = css`
	background: #555;
	color: white;
	border-radius: 5px;
	display: inline-block;
	padding: 1px 4px;
`;

const c_location_listing = css`
	margin-block: 20px;
	background: cornsilk;
	border: 3px dashed khaki;
	border-radius: 10px;
	padding: 10px;
	cursor: pointer;
	color: black;
	&:hover {
		border-color: blue;
		filter: none;
	}
`;

function RequestHelpDlg(p: IPost) {
	let el: HTMLDivElement;
	let el_phone: HTMLInputElement;

	const l = makeAutoObservable({
		phone: '',
		name: '',
		message: ''
	});

	function send_request() {
		el_phone.focus();
		if (!validate_phone(l.phone)) {
			openToast('Invalid phone number', true);
			return;
		}

		l.phone = format_phone(l.phone);
		let message = `Request from Bit Of Help. Call back ${l.name ? '(' + l.name + ') ' : ''}${l.phone}`;
		api.send_text({
			phone: p.phone,
			message
			//test: true
		});
		openToast('Help Request Sent');
		dlg.close(el);
	}

	return (
		<div class="dlgbg" ref={el}>
			<div class="dlg">
				<div class="dlg-header">Request Help From {p.name}</div>
				<div class="dlg-content">
					<p style={{ 'margin-top': 0 }}>Enter your call back info and the provider will be notified.</p>
					<div class="row" style={{ margin: 'auto', width: '250px' }}>
						<label>Phone Number (required)</label>
						<input
							type="tel"
							value={l.phone}
							onChange={(e) => (l.phone = e.target.value)}
							ref={(e) => [(el_phone = e), autofocus(e)]}
						/>
					</div>
					<div class="row" style={{ margin: 'auto', width: '250px', 'margin-top': '10px' }}>
						<label>Name (optional)</label>
						<input value={l.name} onChange={(e) => (l.name = e.target.value)} />
					</div>
					{/* <div class="row">
						<label>Message (required)</label>
						<input />
					</div> */}
				</div>
				<div class="dlg-footer">
					<button onClick={(e) => dlg.close(el)}>Cancel</button>
					<button class="primary" onClick={(e) => send_request()}>
						Send Request
					</button>
				</div>
			</div>
		</div>
	);
}

function LocDlg(p: { l: ILocSummary }) {
	const l = p.l;

	let el: HTMLDivElement;
	return (
		<div class="dlgbg" ref={el}>
			<div class="dlg">
				<div class="dlg-header">
					Help Offered ({l.name}
					{l.state ? ', ' + l.state : ''})
				</div>
				<div class="dlg-content flex gap20 column">
					{l.posts.map((p) => (
						<div class={c_post}>
							<div style={{ display: 'flex', 'margin-bottom': '10px' }}>
								<span class="grow underline">{p.name}</span>
								<span>
									👍
									<span style={{ color: 'goldenrod', 'font-weight': 'bold', 'font-size': '14px' }}>
										2
									</span>
								</span>
								{/* ⭐ */}
								{/* {p.active ? (
									<div class={c_tag}>Active</div>
								) : (
									<div class={c_inactive_tag}>Inactive</div>
								)} */}
							</div>
							{p.title && <div style={{ color: 'green' }}>{p.title}</div>}
							{p.description && <div style={{ color: 'green' }}>{p.description}</div>}
							{/* <div style={{ color: 'teal', 'margin-top': '4px', 'margin-bottom': '4px' }}>
								{p.tags.join(', ')}
							</div> */}
							<div style={{ 'margin-top': '10px' }} class="flex gap10 center">
								{p.contact_type !== ContactType.phone && (
									<button class="primary" onClick={(e) => dlg.open(RequestHelpDlg, p)}>
										Request Help
									</button>
								)}
								{p.contact_type === ContactType.message_phone && <span>or</span>}
								{p.contact_type !== ContactType.message && (
									<a href={'tel:' + p.phone.replaceAll(' ', '-')}>Call: {p.phone}</a>
								)}
							</div>
							{/* <div style={{ color: '#555' }}>Last Active (1/23/2026)</div> */}
						</div>
					))}
				</div>
				<div class="dlg-footer">
					<button onClick={(e) => dlg.close(el)}>Close</button>
				</div>
			</div>
		</div>
	);
}

export function NewHomePage() {
	state.n = useNavigate();

	state.show_user_bar = true;
	async function init() {
		const loc_map = new Map<number, ILocSummary>();

		await state_init;
		l.loading = false;
		for (let p of state.posts) {
			let ls = loc_map.get(p.loc_id);
			if (!ls) {
				ls = {
					name: p.location.name,
					id: p.id,
					providers: 0,
					active: 0,
					state: p.location.state,
					zip: p.location.zip_code,
					posts: []
				};

				loc_map.set(p.loc_id, ls);
			}
			ls.posts.push(p);
			ls.active++;
			ls.providers++;
		}

		l.locations = [...loc_map.values()];
	}

	//init();

	createEffect(() => {
		console.log(state.posts.length);
		init();
	});

	return (
		<main id="app_content">
			<p>Bit of Help connects people that need a bit of help with people that want to help.</p>
			<p>
				Including but not limited to:{' '}
				<mark style={{ color: 'darkgoldenrod', background: 0 }}>
					Food, Gas, Clothing, Utility/Rent Payment, Transportation, Advice/Counsel.
				</mark>
			</p>
			<p>
				Try to find help from providers near your location otherwise view the{' '}
				<i style={{ color: 'green', 'text-decoration': 'underline' }}>Global</i> section. Be sure to follow the{' '}
				<a onClick={(e) => openGuidelines()}>guidelines</a> for saftey. Keep in mind providers help at their own
				discretion and resources.
			</p>

			<h3 style={{ color: 'green' }}>Help Offered as of {new Date().toLocaleDateString()}:</h3>
			{l.loading && <div style={{ margin: '20px', color: 'orange' }}>Loading..</div>}
			{!l.locations.length && !l.loading && <div style={{ margin: '20px', color: 'red' }}>No Help Found</div>}
			<section class="flex gap20">
				<For each={l.locations}>
					{(l) => (
						<button
							class={c_location_listing}
							onClick={(e) => {
								dlg.open(LocDlg, { l });
							}}
						>
							<h4>
								{l.name}
								{l.state && ', ' + l.state}
							</h4>
							<div style={{ color: 'green' }}>
								{l.active} Active {plural('Provider', l.active)}
							</div>
							<div>
								{l.providers} {plural('Provider', l.active)} in the last 30 days{' '}
							</div>
						</button>
					)}
				</For>
			</section>

			<p>
				If you have questions about the platform or need technical assistance{' '}
				<a onClick={(e) => openSupportDlg(null)}>send a message</a> to the support team.
			</p>
			{/* <p>Individuals or groups that would like to register as a provider can do so by creating an Account.</p> */}
			{!state.has_user && (
				<p>
					Providers (individuals or groups) can login or register&nbsp;
					<a style={{}} onClick={openLoginDlg}>
						Here
					</a>
				</p>
			)}
		</main>
	);
}
